/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Collapse from "@mui/material/Collapse";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

function DefaultNavbarLink({
  name,
  openHandler = () => {},
  closeHandler = () => {},
  children,
  collapseStatus,
  collapse,
  light,
  active,
  mobileMenu = false,
  ...rest
}) {
  const isCollapsed = collapse && collapse.length > 0 ? true : false;
  return (
    <>
      <SuiBox
        mx={0.5}
        py={1}
        px={0.5}
        onMouseEnter={isCollapsed && !mobileMenu ? openHandler : undefined}
        onMouseLeave={isCollapsed && !mobileMenu ? closeHandler : undefined}
        display="flex"
        alignItems="baseline"
        color={light ? "text" : "dark"}
        sx={{
          cursor: "pointer",
          userSelect: "none",
          borderBottom: active ? "2px solid #39475E" : "",
        }}
        {...rest}
      >
        <SuiTypography
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          color="inherit"
          sx={{ fontWeight: "100%", whiteSpace: "nowrap", letterSpacing: 0.2 }}
        >
          {name}
        </SuiTypography>
        {isCollapsed && (
          <SuiTypography variant="body2" color={light ? "text" : "dark"}>
            <Icon sx={{ fontWeight: "bold", verticalAlign: "middle" }}>keyboard_arrow_down</Icon>
          </SuiTypography>
        )}
        {!mobileMenu && (
          <Collapse in={Boolean(isCollapsed)} timeout="auto" unmountOnExit>
            {children}
          </Collapse>
        )}
      </SuiBox>
      {mobileMenu && (
        <Collapse in={Boolean(collapseStatus)} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}

// Setting default values for the props of DefaultNavbarLink
DefaultNavbarLink.defaultProps = {
  openHandler: false,
  closeHandler: false,
  children: false,
  collapseStatus: false,
  light: false,
};

// Typechecking props for the DefaultNavbarLink
DefaultNavbarLink.propTypes = {
  name: PropTypes.string.isRequired,
  openHandler: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  closeHandler: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  children: PropTypes.node,
  collapseStatus: PropTypes.bool,
  light: PropTypes.bool,
};

export default DefaultNavbarLink;
